<template>
	<div class="form-new-vehicle pt-2 mt-1" id="form-new-damage">

		<!--<div v-if="!damageId" class="form-new-vehicle-title">Neues Fahrzeug anlegen</div>-->
		<h5 class="mb-2" v-if="damageId">Schadensbilder bearbeiten</h5>
		<h5 class="mb-2" v-else>Schadensbilder erfassen</h5>

		<div class="mt-4" v-show="step == 1">

	        <p class="mb-2 subtitle-highlight">1. Bitte erstellen Sie zunächst <strong>vier</strong> Übersichtsbilder von Ihrem Fahrzeug</p>

	        <div class="mb-4">

	        	<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>a.</strong> Bitte fotografieren Sie das Fahrzeug von <strong>vorne links</strong></p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone1')"><img src="/images/ksr/schaden1.png" class="img-fluid" alt="Schadenbild vorne links" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone1" id="dropzone1" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile1" @vdropzone-success="successFile1" @vdropzone-removed-file="removeFile"></vue-dropzone>
					</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file1')">
	                Bitte laden Sie ein Foto hoch.
	            </div>

	        	<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>b.</strong> Bitte fotografieren Sie das Fahrzeug von <strong>vorne rechts</strong></p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone2')"><img src="/images/ksr/schaden2.png" class="img-fluid" alt="Schadenbild vorne rechts" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone2" id="dropzone2" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile2" @vdropzone-success="successFile2" @vdropzone-removed-file="removeFile"></vue-dropzone>
	        		</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file2')">
	                Bitte laden Sie ein Foto hoch.
	            </div>

	        	<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>c.</strong> Bitte fotografieren Sie das Fahrzeug von <strong>hinten links</strong></p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone3')"><img src="/images/ksr/schaden4.png" class="img-fluid" alt="Schadenbild hinten links" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone3" id="dropzone3" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile3" @vdropzone-success="successFile3" @vdropzone-removed-file="removeFile"></vue-dropzone>
	        		</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file3')">
	                Bitte laden Sie ein Foto hoch.
	            </div>

	        	<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>d.</strong> Bitte fotografieren Sie das Fahrzeug von <strong>hinten rechts</strong></p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone4')"><img src="/images/ksr/schaden3.png" class="img-fluid" alt="Schadenbild hinten rechts"/></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone4" id="dropzone4" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile4" @vdropzone-success="successFile4" @vdropzone-removed-file="removeFile"></vue-dropzone>
	        		</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file4')">
	                Bitte laden Sie ein Foto hoch.
	            </div>

	        </div>

			<div class="d-flex justify-content-center align-items-center gap my-4" style="width:100%" v-if="step != 4">
				<span class="dot" :class="step == 1 ? 'active' : ''" @click="onToggleStep1()"></span>
				<span class="dot" :class="step == 2 ? 'active' : ''" @click="onToggleStep2()"></span>
				<span class="dot" :class="step == 3 ? 'active' : ''" @click="onToggleStep3()"></span>
			</div>

	  		<div class="d-flex justify-content-center align-items-center gap mb-4" style="width:100%">
	  			<button class="btn btn-primary" @click="onToggleStep2">
		  			2. Schadensbereich
		  			<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1"><path d="M5.5 12.1899H19.5" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.5 5.18994L19.5 12.1899L12.5 19.1899" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
		  		</button>
		  	</div>

	    </div>

	    <div class="mt-4" v-show="step == 2">

	    	<p class="mb-4 subtitle-highlight">
	    		2. Bitte erstellen Sie nun <strong>Bilder zum Schadensbereich</strong><br />
	    		Für jeden Schadenbereich benötigen wir ein Bild aus einem Abstand von ca. 2m und zusätzliche Bilder aus der Nähe.
	    	</p>

	    	<div class="form-group d-sm-flex align-items-center" style="width:100%">
			    <label class="form-label mt-0">An wie vielen Stellen ist Ihr Fahrzeug beschädigt:</label>
        		<div class="ml-2 wrap-no-damages">
					<select v-model="numberOfDamages" class="number-of-damages">
						<option value="1">1 Stelle</option>
						<option value="2">2 Stellen</option>
						<option value="3">3 Stellen</option>
						<option value="4">4 Stellen</option>
						<option value="5">5 Stellen</option>
					</select>
        		</div>
			</div>

			<!-- 2.1 Erster Schadensbereich -->
			<div v-show="numberOfDamages > 0" class="damage-detail">
				<p class="label-range mb-1"><strong>2.1 Erster Schadensbereich</strong></p>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>a.</strong> Bitte erstellen Sie <strong>ein Bild aus ca. 2m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone_file_detail_1')"><img src="/images/ksr/schaden2m.png" class="img-fluid" alt="Schadenbild erster Schadensbereich" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_file_detail_1" id="dropzone_file_detail_1" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile_file_detail_1" @vdropzone-success="successFile_file_detail_1" @vdropzone-removed-file="removeFile"></vue-dropzone>
					</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file_detail_1')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>b.</strong> Bitte erstellen Sie <strong>weitere Bilder aus ca. 0.7m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image-detail" @click="openDropzoneDetail('dropzone_files_detail_1')">
	        				<div class="left"><img src="/images/ksr/schaden-close1.png" class="img-fluid" alt="Schadendetailbild 1" /></div>
	        				<div class="right"><img src="/images/ksr/schaden-close2.png" class="img-fluid" alt="Schadendetailbild 2" /></div>
	        			</div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_files_detail_1" id="dropzone_files_detail_1" :options="dropzoneOptionsMultiple" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles_files_detail_1" @vdropzone-success-multiple="successFiles_files_detail_1" @vdropzone-removed-file="removeFile"></vue-dropzone>
						<button class="add-more-images" @click="openDropzoneDetail('dropzone_files_detail_1')">+ weitere Bilder hinzufügen</button>
					</div>
				</div>
				<div class="invalid-feedback d-block" v-if="formdata_errors.includes('files_detail_1')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
		    </div>

		    <hr class="my-4" style="border-top:2px solid #ccc;" v-show="numberOfDamages > 1" />

		    <!-- 2.2 Zweiter Schadensbereich -->
		    <div v-show="numberOfDamages > 1" class="damage-detail">
				<p class="label-range mb-1"><strong>2.2 Zweiter Schadensbereich</strong></p>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>a.</strong> Bitte erstellen Sie <strong>ein Bild aus ca. 2m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone_file_detail_2')"><img src="/images/ksr/schaden2m.png" class="img-fluid" alt="Schadenbild zweiter Schadensbereich" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_file_detail_2" id="dropzone_file_detail_2" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile_file_detail_2" @vdropzone-success="successFile_file_detail_2" @vdropzone-removed-file="removeFile"></vue-dropzone>
					</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file_detail_2')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>b.</strong> Bitte erstellen Sie <strong>weitere Bilder aus ca. 0.7m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image-detail" @click="openDropzoneDetail('dropzone_files_detail_2')">
	        				<div class="left"><img src="/images/ksr/schaden-close1.png" class="img-fluid" alt="Schadendetailbild 1" /></div>
	        				<div class="right"><img src="/images/ksr/schaden-close2.png" class="img-fluid" alt="Schadendetailbild 2" /></div>
	        			</div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_files_detail_2" id="dropzone_files_detail_2" :options="dropzoneOptionsMultiple" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles_files_detail_2" @vdropzone-success-multiple="successFiles_files_detail_2" @vdropzone-removed-file="removeFile"></vue-dropzone>
						<button class="add-more-images" @click="openDropzoneDetail('dropzone_files_detail_2')">+ weitere Bilder hinzufügen</button>
					</div>
				</div>
				<div class="invalid-feedback d-block" v-if="formdata_errors.includes('files_detail_2')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
		    </div>

		    <hr class="my-4" style="border-top:2px solid #ccc;" v-show="numberOfDamages > 2" />

		    <!-- 2.3 Dritter Schadensbereich -->
		    <div v-show="numberOfDamages > 2" class="damage-detail">
				<p class="label-range mb-1"><strong>2.3 Dritter Schadensbereich</strong></p>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>a.</strong> Bitte erstellen Sie <strong>ein Bild aus ca. 2m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone_file_detail_3')"><img src="/images/ksr/schaden2m.png" class="img-fluid" alt="Schadenbild dritter Schadensbereich" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_file_detail_3" id="dropzone_file_detail_3" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile_file_detail_3" @vdropzone-success="successFile_file_detail_3" @vdropzone-removed-file="removeFile"></vue-dropzone>
					</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file_detail_3')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>b.</strong> Bitte erstellen Sie <strong>weitere Bilder aus ca. 0.7m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image-detail" @click="openDropzoneDetail('dropzone_files_detail_3')">
	        				<div class="left"><img src="/images/ksr/schaden-close1.png" class="img-fluid" alt="Schadendetailbild 1" /></div>
	        				<div class="right"><img src="/images/ksr/schaden-close2.png" class="img-fluid" alt="Schadendetailbild 2" /></div>
	        			</div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_files_detail_3" id="dropzone_files_detail_3" :options="dropzoneOptionsMultiple" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles_files_detail_3" @vdropzone-success-multiple="successFiles_files_detail_3" @vdropzone-removed-file="removeFile"></vue-dropzone>
						<button class="add-more-images" @click="openDropzoneDetail('dropzone_files_detail_3')">+ weitere Bilder hinzufügen</button>
					</div>
				</div>
				<div class="invalid-feedback d-block" v-if="formdata_errors.includes('files_detail_3')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
		    </div>

		    <hr class="my-4" style="border-top:2px solid #ccc;" v-show="numberOfDamages > 3" />

		    <!-- 2.4 Vierter Schadensbereich -->
		    <div v-show="numberOfDamages > 3" class="damage-detail">
				<p class="label-range mb-1"><strong>2.4 Vierter Schadensbereich</strong></p>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>a.</strong> Bitte erstellen Sie <strong>ein Bild aus ca. 2m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone_file_detail_4')"><img src="/images/ksr/schaden2m.png" class="img-fluid" alt="Schadenbild vierter Schadensbereich" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_file_detail_4" id="dropzone_file_detail_4" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile_file_detail_4" @vdropzone-success="successFile_file_detail_4" @vdropzone-removed-file="removeFile"></vue-dropzone>
					</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file_detail_4')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>b.</strong> Bitte erstellen Sie <strong>weitere Bilder aus ca. 0.7m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image-detail" @click="openDropzoneDetail('dropzone_files_detail_4')">
	        				<div class="left"><img src="/images/ksr/schaden-close1.png" class="img-fluid" alt="Schadendetailbild 1" /></div>
	        				<div class="right"><img src="/images/ksr/schaden-close2.png" class="img-fluid" alt="Schadendetailbild 2" /></div>
	        			</div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_files_detail_4" id="dropzone_files_detail_4" :options="dropzoneOptionsMultiple" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles_files_detail_4" @vdropzone-success-multiple="successFiles_files_detail_4" @vdropzone-removed-file="removeFile"></vue-dropzone>
						<button class="add-more-images" @click="openDropzoneDetail('dropzone_files_detail_4')">+ weitere Bilder hinzufügen</button>
					</div>
				</div>
				<div class="invalid-feedback d-block" v-if="formdata_errors.includes('files_detail_4')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
		    </div>

		    <hr class="my-4" style="border-top:2px solid #ccc;" v-show="numberOfDamages > 4" />

		    <!-- 2.5 Fünfter Schadensbereich -->
			<div v-show="numberOfDamages > 4" class="damage-detail">
				<p class="label-range mb-1"><strong>2.5 Fünfter Schadensbereich</strong></p>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>a.</strong> Bitte erstellen Sie <strong>ein Bild aus ca. 2m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone_file_detail_5')"><img src="/images/ksr/schaden2m.png" class="img-fluid" alt="Schadenbild fünfter Schadensbereich" /></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_file_detail_5" id="dropzone_file_detail_5" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile_file_detail_5" @vdropzone-success="successFile_file_detail_5" @vdropzone-removed-file="removeFile"></vue-dropzone>
					</div>
	        	</div>
	        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file_detail_5')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
				<div class="row no-gutters mb-2">
	        		<p class="label-range mb-1"><strong>b.</strong> Bitte erstellen Sie <strong>weitere Bilder aus ca. 0.7m Entfernung</strong>.</p>
	        		<div class="col-sm-5">
	        			<div class="example-image-detail" @click="openDropzoneDetail('dropzone_files_detail_5')">
	        				<div class="left"><img src="/images/ksr/schaden-close1.png" class="img-fluid" alt="Schadendetailbild 1" /></div>
	        				<div class="right"><img src="/images/ksr/schaden-close2.png" class="img-fluid" alt="Schadendetailbild 2" /></div>
	        			</div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone_files_detail_5" id="dropzone_files_detail_5" :options="dropzoneOptionsMultiple" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles_files_detail_5" @vdropzone-success-multiple="successFiles_files_detail_5" @vdropzone-removed-file="removeFile"></vue-dropzone>
						<button class="add-more-images" @click="openDropzoneDetail('dropzone_files_detail_5')">+ weitere Bilder hinzufügen</button>
					</div>
				</div>
				<div class="invalid-feedback d-block" v-if="formdata_errors.includes('files_detail_5')">
	                Bitte laden Sie ein Foto hoch.
	            </div>
		    </div>

			<div class="d-flex justify-content-center align-items-center gap my-4" style="width:100%" v-if="step != 4">
				<span class="dot" :class="step == 1 ? 'active' : ''" @click="onToggleStep1()"></span>
				<span class="dot" :class="step == 2 ? 'active' : ''" @click="onToggleStep2()"></span>
				<span class="dot" :class="step == 3 ? 'active' : ''" @click="onToggleStep3()"></span>
			</div>

			<div class="d-flex justify-content-between align-items-center gap mb-2 prev-next" style="width:100%">
				<button class="btn btn-primary" @click="onToggleStep1">
					<svg style="transform:rotate(180deg);" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1"><path d="M5.5 12.1899H19.5" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.5 5.18994L19.5 12.1899L12.5 19.1899" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
		  			1. Übersichtsbilder
		  		</button>
	  			<button class="btn btn-primary" @click="onToggleStep3">
		  			3. Tacho
		  			<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1"><path d="M5.5 12.1899H19.5" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.5 5.18994L19.5 12.1899L12.5 19.1899" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
		  		</button>
		  	</div>

	    </div>

	    <div class="mt-4" v-show="step == 3">

	    	<p class="mb-4 subtitle-highlight">
	    		3. Tacho<br />
	    		Bitte fotografieren Sie abschließend Ihren <strong>Tacho mit aktivierte Zündung</strong>.
	    	</p>

			<div class="mb-4">

	        	<div class="row no-gutters mb-2">
	        		<div class="col-sm-5">
	        			<div class="example-image" @click="openDropzoneDetail('dropzone6')"><img src="/images/ksr/tacho.jpg" class="img-fluid" alt="Bild Tacho" ></div>
	        		</div>
	        		<div class="col-sm-7 pl-2 dropzone-wrapper-damages">
						<vue-dropzone ref="myVueDropzone6" id="dropzone6" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-sending="sendingFile6" @vdropzone-success="successFile6" @vdropzone-removed-file="removeFile"></vue-dropzone>
	        		</div>
		        	<div class="invalid-feedback d-block" v-if="formdata_errors.includes('file6')">
		                Bitte laden Sie ein Foto hoch.
		            </div>
	        	</div>

	        </div>

			<div class="d-flex justify-content-center align-items-center gap my-4" style="width:100%" v-if="step != 4">
				<span class="dot" :class="step == 1 ? 'active' : ''" @click="onToggleStep1()"></span>
				<span class="dot" :class="step == 2 ? 'active' : ''" @click="onToggleStep2()"></span>
				<span class="dot" :class="step == 3 ? 'active' : ''" @click="onToggleStep3()"></span>
			</div>

	        <div class="d-flex justify-content-between align-items-center gap mb-2 prev-next" style="width:100%">
				<button class="btn btn-primary" @click="onToggleStep2">
					<svg style="transform:rotate(180deg);" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1"><path d="M5.5 12.1899H19.5" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.5 5.18994L19.5 12.1899L12.5 19.1899" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
		  			2. Schadensbereich
		  		</button>
		  		<button class="btn btn-primary" style="background-color:#0d960d !important;" @click="onCreateDamage()" :disabled='formErrors' :class="{ disabled: formErrors }">
		  			<div class="spinner-border text-white mr-2" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                    </div>
		  			<span v-if="damageId">Schadenerfassung speichern</span>
		  			<span v-else>Schadenerfassung beenden</span>
		  		</button>
		  	</div>
		  	<div class="invalid-feedback d-block" v-if="formdata_errors.length > 0">
                Bitte überprüfen Sie alle Felder.
            </div>

	    </div>

		<div class="mt-4" v-show="step == 4">

	    	<p class="mb-4 subtitle-highlight">
	    		Vielen Dank!
	    	</p>

	    </div>

		<div class="allowed-filetypes my-2"><sup>*</sup> Erlaubte Dateitypen: .jpg, .png, maximale Dateigröße 50MB</div>

		<div class="btn-delete-wrapper">
			<button class="btn btn-secondary btn-new-vehicle-cancel" @click="cancelCreateEdit()" :disabled="loading">
			    Abbrechen
			</button>
			<button v-if="damageId" class="btn btn-danger btn-new-vehicle-cancel" @click="onDeleteDamage()" :disabled="loading">
			    Schaden löschen
			</button>
		</div>

	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
//import AttachmentList from "./AttachmentList";
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {

	components: { vueDropzone: vue2Dropzone },

    name: "KSRAddDamage",
    data() {
        return {
        	loading:false,
        	step:1,
        	//damages: [],
            dropzoneOptions: {
				url: '/api/ksr/upload/damages/temp',
			    paramName: function(n) {
                    return "file[]";
                },
				maxFilesize: 50,
                thumbnailWidth: 250,
                thumbnailHeight: 140,
				uploadMultiple: false,
				acceptedFiles: 'image/*',
				dictDefaultMessage: "Dateien hier ablegen oder Foto machen<sup>*</sup>",
				dictRemoveFile: "Löschen",
				dictCancelUpload: "Abbrechen",
				dictCancelUploadConfirmation: "Sicher",
				addRemoveLinks: true,
				maxFiles: 1
			},
            dropzoneOptionsMultiple: {
				url: '/api/ksr/upload/damages/temp',
			    paramName: function(n) {
                    return "file[]";
                },
				maxFilesize: 50,
                thumbnailWidth: 250,
                thumbnailHeight: 140,
				uploadMultiple: true,
				parallelUploads: 1,
				acceptedFiles: 'image/*',
				dictDefaultMessage: "Dateien hier ablegen oder Fotos machen<sup>*</sup>",
				dictRemoveFile: "Löschen",
				dictCancelUpload: "Abbrechen",
				dictCancelUploadConfirmation: "Sicher",
				addRemoveLinks: true
			},
		    tempAttachments: [],
            formdata: {
            	file1: '',
	            file2: '',
	            file3: '',
	            file4: '',
	            files5: [],
	            file6: '',
	            file_detail_1: '',
	            files_detail_1: [],
	            file_detail_2: '',
	            files_detail_2: [],
	            file_detail_3: '',
	            files_detail_3: [],
	            file_detail_4: '',
	            files_detail_4: [],
	            file_detail_5: '',
	            files_detail_5: [],
	            description: '',
	            damageId: false
	        },
	        numberOfDamages: 1,
            formdata_errors: [],
        }
    },
 	created() {
 		if(this.damageId) {
 			this.getDamage(this.damageId);
 		}
    },
    computed: {
	    formErrors: function () {
			let formdata_errors = false;
			if(this.formdata.file1 == '') { formdata_errors = true; }
			if(this.formdata.file2 == '') { formdata_errors = true; }
			if(this.formdata.file3 == '') { formdata_errors = true; }
			if(this.formdata.file4 == '') { formdata_errors = true; }
			if(this.formdata.file6 == '') { formdata_errors = true; }
			if(this.formdata.file_detail_1 == '') { formdata_errors = true; }
			if(this.formdata.files_detail_1.length == 0) { formdata_errors = true; }
			if(this.numberOfDamages == 2) {
				if(this.formdata.file_detail_2 == '') { formdata_errors = true; }
				if(this.formdata.files_detail_2.length == 0) { formdata_errors = true; }
			}
			if(this.numberOfDamages == 3) {
				if(this.formdata.file_detail_3 == '') { formdata_errors = true; }
				if(this.formdata.files_detail_3.length == 0) { formdata_errors = true; }
			}
			if(this.numberOfDamages == 4) {
				if(this.formdata.file_detail_4 == '') { formdata_errors = true; }
				if(this.formdata.files_detail_4.length == 0) { formdata_errors = true; }
			}
			if(this.numberOfDamages == 5) {
				if(this.formdata.file_detail_5 == '') { formdata_errors = true; }
				if(this.formdata.files_detail_5.length == 0) { formdata_errors = true; }
			}
			return formdata_errors;
	    }
	},
    methods: {

    	onToggleStep1() {
    		this.step = 1;
		    this.scrollToFormTop();
    	},
    	onToggleStep2() {
    		this.step = 2;
    		this.scrollToFormTop();
    	},
    	onToggleStep3() {
    		this.step = 3;
    		this.scrollToFormTop();
    	},
    	onToggleFinish() {
    		this.step = 4;
    		//this.scrollToFormTop();
    	},

    	scrollToFormTop() {
			setTimeout(function() {
				var element = document.querySelector("#form-new-damage");
	    		element.scrollIntoView();
			}, 200);
    	},

    	// UPLOAD METHODS
		fileAdded(file) {
            // Construct your file object to render in the UI
            /*let attachment = {};
            attachment._id = file.upload.uuid;
            attachment.title = file.name;
            attachment.type = "file";
            attachment.extension = "." + file.type.split("/")[1];
            attachment.content = "File Upload by Select or Drop";
            attachment.thumb = file.dataURL;
            attachment.thumb_list = file.dataURL;
            attachment.isLoading = true;
            attachment.progress = null;
            attachment.size = file.size;
            this.tempAttachments = [...this.tempAttachments, attachment];*/
        },
        // a middle layer function where you can change the XHR request properties
        sendingFile1(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'front_left');
        },
        sendingFile2(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'front_right');
        },
        sendingFile3(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'rear_left');
        },
        sendingFile4(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'rear_right');
        },
        sendingFiles5(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'detail');
        },
        sendingFile6(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'tacho');
        },
        sendingFile_file_detail_1(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'file_detail_1');
        },
        sendingFiles_files_detail_1(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'files_detail_1');
        },
        sendingFile_file_detail_2(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'file_detail_2');
        },
        sendingFiles_files_detail_2(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'files_detail_2');
        },
        sendingFile_file_detail_3(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'file_detail_3');
        },
        sendingFiles_files_detail_3(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'files_detail_3');
        },
        sendingFile_file_detail_4(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'file_detail_4');
        },
        sendingFiles_files_detail_4(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'files_detail_4');
        },
        sendingFile_file_detail_5(file, xhr, formData) {
        	formData.append('uuid', file.upload.uuid);
            formData.append('type', 'file_detail_5');
        },
        sendingFiles_files_detail_5(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'files_detail_5');
        },
        // function where we get the upload progress
        /*uploadProgress(file, progress, bytesSent) {
            //console.log("File Upload Progress", progress);
            this.tempAttachments.map(attachment => {
            if (attachment.title === file.name) {
              attachment.progress = `${Math.floor(progress)}`;
            }
          });
        },*/
        // called on successful upload of a file
        successFile1(file, response) {
            this.formdata.file1 = response[0];
        },
        successFile2(file, response) {
            this.formdata.file2 = response[0];
        },
        successFile3(file, response) {
            this.formdata.file3 = response[0];
        },
        successFile4(file, response) {
            this.formdata.file4 = response[0];
        },
        successFiles5(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files5.push(response[k]);
        	}
        },
        successFile6(files, response) {
            this.formdata.file6 = response[0];
        },
        successFile_file_detail_1(file, response) {
            this.formdata.file_detail_1 = response[0];
        },
        successFiles_files_detail_1(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files_detail_1.push(response[k]);
        	}
        },
        successFile_file_detail_2(file, response) {
            this.formdata.file_detail_2 = response[0];
        },
        successFiles_files_detail_2(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files_detail_2.push(response[k]);
        	}
        },
        successFile_file_detail_3(file, response) {
            this.formdata.file_detail_3 = response[0];
        },
        successFiles_files_detail_3(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files_detail_3.push(response[k]);
        	}
        },
        successFile_file_detail_4(file, response) {
            this.formdata.file_detail_4 = response[0];
        },
        successFiles_files_detail_4(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files_detail_4.push(response[k]);
        	}
        },
        successFile_file_detail_5(file, response) {
            this.formdata.file_detail_5 = response[0];
        },
        successFiles_files_detail_5(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files_detail_5.push(response[k]);
        	}
        },
        removeFile(file, error, xhr) {
        	//console.log(file);
        	if(file.manuallyAdded) {
        		// edit manually added files when editing
	        	if(this.formdata.file1 == file.name) { this.formdata.file1 = ''; }
	        	if(this.formdata.file2 == file.name) { this.formdata.file2 = ''; }
	        	if(this.formdata.file3 == file.name) { this.formdata.file3 = ''; }
	        	if(this.formdata.file4 == file.name) { this.formdata.file4 = ''; }
	        	for(var k = 0; k < this.formdata.files5.length; k++) {
	        		if(this.formdata.files5[k] == file.name) { this.formdata.files5.splice(k, 1); }
	        	}
	        	if(this.formdata.file6 == file.name) { this.formdata.file6 = ''; }
	        	if(this.formdata.file_detail_1 == file.name) { this.formdata.file_detail_1 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_1.length; k++) {
	        		if(this.formdata.files_detail_1[k] == file.name) { this.formdata.files_detail_1.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_2 == file.name) { this.formdata.file_detail_2 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_2.length; k++) {
	        		if(this.formdata.files_detail_2[k] == file.name) { this.formdata.files_detail_2.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_3 == file.name) { this.formdata.file_detail_3 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_3.length; k++) {
	        		if(this.formdata.files_detail_3[k] == file.name) { this.formdata.files_detail_3.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_4 == file.name) { this.formdata.file_detail_4 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_4.length; k++) {
	        		if(this.formdata.files_detail_4[k] == file.name) { this.formdata.files_detail_4.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_5 == file.name) { this.formdata.file_detail_5 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_5.length; k++) {
	        		if(this.formdata.files_detail_5[k] == file.name) { this.formdata.files_detail_5.splice(k, 1); }
	        	}
        	}
        	else {
        		// new files
        		let uuidArr = file.upload.uuid.split('-');
        		let uuidShort = uuidArr[uuidArr.length - 1];
	        	if(this.formdata.file1.includes(uuidShort)) { this.formdata.file1 = ''; }
	        	if(this.formdata.file2.includes(uuidShort)) { this.formdata.file2 = ''; }
	        	if(this.formdata.file3.includes(uuidShort)) { this.formdata.file3 = ''; }
	        	if(this.formdata.file4.includes(uuidShort)) { this.formdata.file4 = ''; }
	        	for(var k = 0; k < this.formdata.files5.length; k++) {
	        		if(this.formdata.files5[k].includes(uuidShort)) { this.formdata.files5.splice(k, 1); }
	        	}
	        	if(this.formdata.file6.includes(uuidShort)) { this.formdata.file6 = ''; }
	        	if(this.formdata.file_detail_1.includes(uuidShort)) { this.formdata.file_detail_1 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_1.length; k++) {
	        		if(this.formdata.files_detail_1[k].includes(uuidShort)) { this.formdata.files_detail_1.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_2.includes(uuidShort)) { this.formdata.file_detail_2 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_2.length; k++) {
	        		if(this.formdata.files_detail_2[k].includes(uuidShort)) { this.formdata.files_detail_2.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_3.includes(uuidShort)) { this.formdata.file_detail_3 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_3.length; k++) {
	        		if(this.formdata.files_detail_3[k].includes(uuidShort)) { this.formdata.files_detail_3.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_4.includes(uuidShort)) { this.formdata.file_detail_4 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_4.length; k++) {
	        		if(this.formdata.files_detail_4[k].includes(uuidShort)) { this.formdata.files_detail_4.splice(k, 1); }
	        	}
	        	if(this.formdata.file_detail_5.includes(uuidShort)) { this.formdata.file_detail_5 = ''; }
	        	for(var k = 0; k < this.formdata.files_detail_5.length; k++) {
	        		if(this.formdata.files_detail_5[k].includes(uuidShort)) { this.formdata.files_detail_5.splice(k, 1); }
	        	}

        	}
        },

    	onCreateDamage() {

    		this.message = '';

    		// validation
    		this.formdata_errors = [];
    		if(this.formdata.file1 == '') {
    			this.formdata_errors.push('file1');
    		}
    		if(this.formdata.file2 == '') {
    			this.formdata_errors.push('file2');
    		}
    		if(this.formdata.file3 == '') {
    			this.formdata_errors.push('file3');
    		}
    		if(this.formdata.file4 == '') {
    			this.formdata_errors.push('file4');
    		}
    		/*if(this.formdata.files5 == '') {
    			this.formdata_errors.push('files5');
    		}*/
    		if(this.formdata.file6 == '') {
    			this.formdata_errors.push('file6');
    		}
    		if(this.formdata.file_detail_1 == '') {
    			this.formdata_errors.push('file_detail_1');
    		}
    		if(this.formdata.files_detail_1 == '') {
    			this.formdata_errors.push('files_detail_1');
    		}
    		/*if(this.formdata.file_detail_2 == '') {
    			this.formdata_errors.push('file_detail_2');
    		}
    		if(this.formdata.files_detail_2 == '') {
    			this.formdata_errors.push('files_detail_2');
    		}
    		if(this.formdata.file_detail_3 == '') {
    			this.formdata_errors.push('file_detail_3');
    		}
    		if(this.formdata.files_detail_3 == '') {
    			this.formdata_errors.push('files_detail_3');
    		}
    		if(this.formdata.file_detail_4 == '') {
    			this.formdata_errors.push('file_detail_4');
    		}
    		if(this.formdata.files_detail_4 == '') {
    			this.formdata_errors.push('files_detail_4');
    		}
    		if(this.formdata.file_detail_5 == '') {
    			this.formdata_errors.push('file_detail_5');
    		}
    		if(this.formdata.files_detail_5 == '') {
    			this.formdata_errors.push('files_detail_5');
    		}*/
    		/*if(this.formdata.description == '') {
    			this.formdata_errors.push('description');
    		}*/

            // validation ok
            if(!this.formdata_errors.length) {

            	let token = false;
            	let searchParams = new URLSearchParams(window.location.search);
            	if(searchParams.has('t')) {
            		// booklyn token
            		token = searchParams.get('t');
            	}

	    		var data = {
	        		formdata: this.formdata,
	        		storeId: this.storeId,
	        		jobId: this.jobId,
	        		damageToken: this.damageToken,
	        		token: token
	   			}

	   			var _this = this;

	   			_this.loading = true;
	    		axios.post('/api/ksr/create-damage/?identityToken='+this.kit, data)
		        .then((response) => {
		        	//console.log(response.data.status);
		            //this.vehicles = response.data.value;
		            /*if(response.data.status == 'exists') {
		            	_this.message = 'Fahrzeug existiert bereits.';
		            }
		            */
		            if(response.data.status == 'created') {
		            	_this.onToggleFinish();
		            	//_this.message = 'Fahrzeug wurde erfolgreich gespeichert.';
		            	//_this.vehicles.push(response.data.vehicle);
		            	//_this.$parent.refreshVehicles();
		            	_this.$emit("refresh", response.data.damage.id);
		            	_this.$emit("created");
		            	//this.$emit("setvehicle", response.data.vehicle.id);
		            	//_this.$emit("setdamage", response.data.damage);
		            }
		            /*if(response.data.status == 'created-single') {
		            	_this.$emit("refreshSingle", response.data.damage.id);
		            }*/
		            _this.loading = false;
		        });

		        //this.$parent.refreshVehicles();

		    }
    	},
    	getDamage(damageId) {

    		let endpoint = '/api/ksr/damage/' + damageId;
			let searchParams = new URLSearchParams(window.location.search);
			if(searchParams.has('t')) {
				// booklyn token
				endpoint = '/api/ksr/damage/' + damageId + '?t=' + searchParams.get('t');
			}
			if(!searchParams.has('t') && this.damageToken) {
				endpoint = '/api/ksr/damage/' + damageId + '?damageToken=' + this.damageToken;
			}

			endpoint += '&identityToken=' + this.kit;

            var _this = this;
            axios.get(endpoint)
            .then((response) => {
            	console.log(response);
            	_this.formdata.file1 = response.data.file1;
            	_this.formdata.file2 = response.data.file2;
            	_this.formdata.file3 = response.data.file3;
            	_this.formdata.file4 = response.data.file4;
            	_this.formdata.files5 = response.data.files5;
            	_this.formdata.file6 = response.data.file6;
            	_this.formdata.file_detail_1 = response.data.file_detail_1;
            	_this.formdata.files_detail_1 = response.data.files_detail_1;
            	_this.formdata.file_detail_2 = response.data.file_detail_2;
            	_this.formdata.files_detail_2 = response.data.files_detail_2;
            	_this.formdata.file_detail_3 = response.data.file_detail_3;
            	_this.formdata.files_detail_3 = response.data.files_detail_3;
            	_this.formdata.file_detail_4 = response.data.file_detail_4;
            	_this.formdata.files_detail_4 = response.data.files_detail_4;
            	_this.formdata.file_detail_5 = response.data.file_detail_5;
            	_this.formdata.files_detail_5 = response.data.files_detail_5;
            	_this.formdata.description = response.data.description;
            	_this.formdata.damageId = response.data.id;

            	let file, url;

            	if(response.data.file1) {
	            	file = { size: 100000, name: response.data.file1, type: "image/*" };
			     	url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file1;
			      	this.$refs.myVueDropzone1.manuallyAddFile(file, url);
			    }

		      	if(response.data.file2) {
	            	file = { size: 100000, name: response.data.file2, type: "image/*" };
			     	url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file2;
			      	this.$refs.myVueDropzone2.manuallyAddFile(file, url);
			    }

		      	if(response.data.file3) {
	            	file = { size: 100000, name: response.data.file3, type: "image/*" };
			     	url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file3;
			      	this.$refs.myVueDropzone3.manuallyAddFile(file, url);
			    }

		      	if(response.data.file4) {
            		file = { size: 100000, name: response.data.file4, type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file4;
		      		this.$refs.myVueDropzone4.manuallyAddFile(file, url);
		      	}

	        	for(var k = 0; k < response.data.files5.length; k++) {
	        		file = { size: 100000, name: response.data.files5[k], type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.files5[k];
		      		this.$refs.myVueDropzone5.manuallyAddFile(file, url);
	        	}

	        	if(response.data.file6) {
	            	file = { size: 100000, name: response.data.file6, type: "image/*" };
			     	url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file6;
			      	this.$refs.myVueDropzone6.manuallyAddFile(file, url);
			    }

		      	if(response.data.file_detail_1) {
					file = { size: 100000, name: response.data.file_detail_1, type: "image/*" };
			     	url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file_detail_1;
			      	this.$refs.myVueDropzone_file_detail_1.manuallyAddFile(file, url);
			    }

	        	for(var k = 0; k < response.data.files_detail_1.length; k++) {
	        		file = { size: 100000, name: response.data.files_detail_1[k], type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.files_detail_1[k];
		      		this.$refs.myVueDropzone_files_detail_1.manuallyAddFile(file, url);
	        	}

	        	if(response.data.file_detail_2) {
		        	file = { size: 100000, name: response.data.file_detail_2, type: "image/*" };
			     	url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file_detail_2;
			      	this.$refs.myVueDropzone_file_detail_2.manuallyAddFile(file, url);
			      }

	        	for(var k = 0; k < response.data.files_detail_2.length; k++) {
	        		file = { size: 100000, name: response.data.files_detail_2[k], type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.files_detail_2[k];
		      		this.$refs.myVueDropzone_files_detail_2.manuallyAddFile(file, url);
	        	}

	        	if(response.data.file_detail_3) {
	        		file = { size: 100000, name: response.data.file_detail_3, type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file_detail_3;
		      		this.$refs.myVueDropzone_file_detail_3.manuallyAddFile(file, url);
		      	}

	        	for(var k = 0; k < response.data.files_detail_3.length; k++) {
	        		file = { size: 100000, name: response.data.files_detail_3[k], type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.files_detail_3[k];
		      		this.$refs.myVueDropzone_files_detail_3.manuallyAddFile(file, url);
	        	}

	        	if(response.data.file_detail_4) {
		        	file = { size: 100000, name: response.data.file_detail_4, type: "image/*" };
			     	url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file_detail_4;
			      	this.$refs.myVueDropzone_file_detail_4.manuallyAddFile(file, url);
			    }

	        	for(var k = 0; k < response.data.files_detail_4.length; k++) {
	        		file = { size: 100000, name: response.data.files_detail_4[k], type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.files_detail_4[k];
		      		this.$refs.myVueDropzone_files_detail_4.manuallyAddFile(file, url);
	        	}

	        	if(response.data.file_detail_5) {
	        		file = { size: 100000, name: response.data.file_detail_5, type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.file_detail_5;
		      		this.$refs.myVueDropzone_file_detail_5.manuallyAddFile(file, url);
		      	}

	        	for(var k = 0; k < response.data.files_detail_5.length; k++) {
	        		file = { size: 100000, name: response.data.files_detail_5[k], type: "image/*" };
		     		url = '/images/ksr/damages/' + response.data.id + '/' + response.data.files_detail_5[k];
		      		this.$refs.myVueDropzone_files_detail_5.manuallyAddFile(file, url);
	        	}

	        	if(_this.formdata.file_detail_1) { _this.numberOfDamages = 1; }
	        	if(_this.formdata.file_detail_2) { _this.numberOfDamages = 2; }
	        	if(_this.formdata.file_detail_3) { _this.numberOfDamages = 3; }
	        	if(_this.formdata.file_detail_4) { _this.numberOfDamages = 4; }
	        	if(_this.formdata.file_detail_5) { _this.numberOfDamages = 5; }

            });
    	},

    	onDeleteDamage() {

    		let endpoint = '/api/ksr/damage/' + this.damageId;
			let searchParams = new URLSearchParams(window.location.search);
			if(searchParams.has('t')) {
				// booklyn token
				endpoint = '/api/ksr/damage/' + this.damageId + '?t=' + searchParams.get('t');
			}

			endpoint += '&identityToken=' + this.kit;

    		let _this = this;
    		if( confirm("Wollen Sie den Schaden wirklich löschen?") ) {
				axios.delete(endpoint)
		        .then((response) => {
		            if(response.data.status == 'deleted') {
		            	_this.$emit("refresh", 99999);
		            }
		            _this.loading = false;
		        });
    		}
    	},

    	cancelCreateEdit() {
    		//if (confirm('Wenn Sie den Vorgang abbrechen wird kein Schaden gespeichert. Fortfahren?') == true) {
			if(this.damageId)
    			this.$emit("refresh", this.damageId);
    		else
    			this.$emit("refresh", false);
    		this.$emit("cancel");
        	//}
        },

        openDropzoneDetail(id) {
        	//this.myVueDropzone_files_detail_1.dropzone().clickableElements[0].click();
        	document.getElementById(id).click();
        }

    	/*refreshDamages() {
	 		this.loading = false;
	 		var _this = this;
	        axios.get('/api/ksr/damages')
	        .then((response) => {
	            _this.damages = response.data;
	            _this.loading = false;
	        });
        }*/


    },
    props: ['kit', 'storeId', 'jobId', 'damageToken', 'damageId']
};
</script>
